import VideoComments from "./VideoComments";
export default function CommentsSection() {
  return <VideoComments />;
}